export enum ImResultSeverityEnum {
    none,
    info,
    warning,
    error,
    abort
}
